// src/components/modals/SetViewerModal.jsx
import React from 'react';
import { X, Zap, BookOpen, ChevronDown } from 'lucide-react';

export default function SetViewerModal({ 
  viewingSet, 
  onClose, 
  onStartPractice, 
  onStartChallenge,
  playSound, 
  zIndex = 500 
}) {
  if (!viewingSet) return null;
  // handleChallenge — agregar junto a handlePractice
const handleChallenge = () => {
  onStartChallenge(viewingSet);
  onClose();
  if (playSound) playSound('start');
};


  const handlePractice = () => {
    const shuffleArray = (array) => {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    };

    const allWords = viewingSet.words || [];
    const limitedWords = shuffleArray(allWords).slice(0, 12);
    
    onStartPractice({ ...viewingSet, words: limitedWords });
    onClose();
    if (playSound) playSound('start');
  };

 return (
  <div 
    className="fixed inset-0 animate-in fade-in duration-300"
    style={{ zIndex: 1000 }}
    onClick={onClose}
  >
    {/* Backdrop */}
    <div className="absolute inset-0 bg-slate-900/80 backdrop-blur-sm" />

    {/* Bottom Sheet */}
    <div
      className="absolute bottom-0 left-0 right-0 bg-white rounded-t-[2.5rem] shadow-2xl flex flex-col animate-in slide-in-from-bottom duration-500"
      style={{ maxHeight: 'calc(100vh - 80px)' }} // ← deja espacio al top navbar
      onClick={(e) => e.stopPropagation()}
    >
      {/* Pastilla indicadora — UX estándar de bottom sheet */}
      <div className="flex justify-center pt-3 pb-1 shrink-0">
        <div className="w-10 h-1 bg-slate-200 rounded-full" />
      </div>

      {/* HEADER */}
      <div className="bg-gradient-to-br from-indigo-600 to-purple-700 mx-3 rounded-[1.5rem] px-4 py-5 shadow-lg relative shrink-0 mb-2">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 p-2 bg-white text-indigo-600 rounded-full shadow-lg hover:scale-110 active:scale-95 transition-all z-10"
        >
          <X size={20} strokeWidth={3} />
        </button>

        <div className="text-center text-white">
          <div className="text-3xl mb-1 drop-shadow-lg">{viewingSet.emoji}</div>
          <h2 className="text-lg sm:text-xl font-black leading-tight px-8">{viewingSet.title}</h2>
          <p className="text-indigo-200 text-[9px] font-bold uppercase tracking-widest mt-0.5">
            Guía de Vocabulario
          </p>
        </div>
      </div>

      {/* LISTA */}
      <div className="flex-1 overflow-y-auto px-4 py-2 space-y-2 min-h-0 custom-scrollbar">
        {viewingSet.words?.map((word, idx) => (
          <div key={idx} className="bg-white p-2.5 sm:p-3.5 rounded-xl border border-slate-100 flex items-center shadow-sm gap-2 hover:border-indigo-200 hover:shadow-md transition-all">
            <div className="flex-1 text-left">
              <span className="font-bold text-slate-800 text-xs sm:text-sm">{word.en}</span>
            </div>

            {word.ipa && (
              <div className="px-1.5 py-0.5 bg-indigo-50 rounded-lg border border-indigo-100 shrink-0">
                <span className="font-mono text-[8px] font-bold text-indigo-500 uppercase">
                  {word.ipa}
                </span>
              </div>
            )}

            <div className="flex-1 text-right">
              <span className="font-bold text-indigo-600 text-xs sm:text-sm">{word.es}</span>
            </div>
          </div>
        ))}
      </div>

      {/* FOOTER — reemplazar completo */}
<div className="px-4 pt-3 pb-8 bg-white border-t border-slate-100 shrink-0 space-y-2">
  <button
    onClick={handlePractice}
    className="w-full bg-indigo-600 text-white py-4 rounded-2xl font-black text-sm shadow-lg shadow-indigo-200 hover:scale-[1.02] active:scale-95 transition-all flex items-center justify-center gap-2 border-b-4 border-indigo-800 active:border-b-0"
  >
    <Zap fill="currentColor" className="text-yellow-400" size={16} />
    PRACTICAR AHORA
  </button>

  <button
    onClick={handleChallenge}
    className="w-full bg-purple-600 text-white py-4 rounded-2xl font-black text-sm shadow-lg shadow-purple-200 hover:scale-[1.02] active:scale-95 transition-all flex items-center justify-center gap-2 border-b-4 border-purple-800 active:border-b-0"
  >
    ⏱️ DESAFÍO CRONOMETRADO
  </button>

  <button
    onClick={onClose}
    className="w-full bg-slate-100 text-slate-500 py-3 rounded-2xl font-black text-xs hover:bg-slate-200 transition-colors flex items-center justify-center gap-2"
  >
    <BookOpen size={14} />
    SOLO LEER
  </button>
</div>

    </div>
  </div>
);

}
